import styled from "@emotion/styled";
import rem from "../../utils/rem/rem";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Link from "../../components/Link/Link";

export const MoaDashboardHeader = styled.div`
  padding: ${rem(48)} ${rem(32)};
  background-color: ${({ theme }) => theme.colors.gray800};
  color: ${({ theme }) => theme.colors.white};
  font-family: 'Pizza Hut', serif;
  flex-direction: row;
  align-items: flex-end;
  height: 100px;
  display: flex;
  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: row;
  }
`;

export const DashboardBody = styled.div`
  width: 100%;
  display: flex;
  min-height: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
`;

export const SideContainers = styled.div`
  background-color: ${({ theme }) => theme.colors.gray100};
  margin-left: 32px;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 0.5;
  height: fit-content;
`;

export const ContainerTranslationItem = styled.div`
  padding: ${rem(16)} 0 0 ${rem(16)};
  background-color: ${({ theme }) => theme.colors.white};
  :last-of-type  {
      padding: ${rem(16)} 0 ${rem(16)} ${rem(16)};
  }
`;

export const H1 = styled.h1`
  font-size: ${rem(28)};
  margin-bottom: ${rem(40)};
`;

export const H2 = styled.h2`
  font-size: ${rem(14)};
  padding: ${rem(1)}
  font-weight: bold;
  font-family: 'Open Sans';
`;

export const H3 = styled(Link)`
width: max-content;
color: ${({ theme }) => theme.colors.darkBlue};
`;
export const HeaderWrapper = styled.div`
    margin-left: ${rem(2.5)};
    padding-right: 40px;
    justify-content: center;
    align-items: center;
`;

export const DropdownWrapperMedium = styled.div`
  padding: ${rem(48)} ${rem(2.5)} ${rem(32)};
  width: ${rem(190)};
`;

export const DashboardMainPanel = styled.div`
    padding: ${rem(16)};
    height: 100%;
    flex-grow: 2;
`;

export const DashboardRow = styled.div`
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
`;

export const DashboardContainer = styled.div`
    margin: ${rem(16)};
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    border-radius: ${rem(8)};
    width: 100%;
    min-height: 150px;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
`;

export const DashboardContainerHeader = styled.div`
  padding: ${rem(16)};
  font-family: 'Pizza Hut', serif;
  font-weight: 400;
  font-size: ${rem(26)};
  color: ${({ theme }) => theme.colors.gray900};
  background-color: ${({ theme }) => theme.colors.gray100};
`;

export const DashboardContainerBody = styled.div`
    padding: ${rem(16)};
    background-color: ${({ theme }) => theme.colors.white};
    flex: 1;
`;

export const DashboardPublishedContainerBody = styled(DashboardContainerBody)`
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
    gap: 5px;
`;

export const ContainerScroll = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  overflow: auto;
`;

export const ContainerContent = styled.ul`
  padding-bottom: ${rem(16)};
  display: flex;
  flex-wrap: nowrap;
`;

export const FromContainer = styled.div`
    padding: ${rem(16)} 0 ${rem(16)} ${rem(16)};
`;

export const UntilContainer = styled.div`
    padding: ${rem(16)} ${rem(40)} ${rem(16)} 0;
`;

export const DividerContainer = styled.div`
    margin: auto;
`;

export const EventsContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 ${rem(40)} 0 0;
`;

export const EventsAmount = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: ${rem(22)};
  color: ${({ theme }) => theme.colors.gray900};
`;

export const EventsSubtitle = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: ${rem(16)};
  color: ${({ theme }) => theme.colors.gray900};
`;


export const ContainersWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
  borderRadius: 10,
  width: '40%',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#f7f7f7',
    border: 0.5,
    borderStyle: 'solid',
    borderColor: '#828282'
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#ffd37e',
  },
}));

export const StyledTitle = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray600};
  padding:${rem(10)} ${rem(16)} ${rem(10)} ${rem(16)};
`;

export const ContainerSubText = styled.div`
 font-size: ${rem(14)};
  padding:${rem(10)} ${rem(16)} ${rem(10)} ${rem(16)};
  font-family: 'Open Sans';
`;

export const ResolvedText = styled.span`
  color: green;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
`;